import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@icon/t-short.svg'
import _imports_1 from '@icon/check.svg'


const _hoisted_1 = { class: "t-shirt__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createBlock(_component_BaseSubHeading, {
    size: "large",
    weight: "600",
    class: _normalizeClass(["t-short", [
      `is_${_ctx.size.toLowerCase()}`,
      {
        't-short__is-bordered': _ctx.bordered || _ctx.onlyLabel,
        't-short__is-selected': _ctx.showTShirtSelected,
        'is-hovered': _ctx.isHovered,
        'is-only-label': _ctx.onlyLabel
      }
    ]])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_icon, {
        data: _imports_0,
        fill: true,
        width: "var(--icon-32)",
        height: "var(--icon-32)"
      }),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
      (_ctx.showTShirtSelected)
        ? (_openBlock(), _createBlock(_component_icon, {
            key: 0,
            data: _imports_1,
            color: "#4CAB26",
            width: "var(--icon-24)",
            height: "var(--icon-24)",
            fill: true,
            class: "t-short__selected-icon"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}